module.exports = __webpack_public_path__ + "public/Icons/changePassword.svg?1c6d01e9";